

const Disclaimer = () => {
    return (
        <>
            <div className="group-action">
                <div className="project-text">
                    <img src="/images/detail-ido/project-dis.svg" alt="" />
                </div>
                <div className="box-dis">
                    <div className="title-dis">
                        Legal Disclaimer
                    </div>
                    <div className="content-dis">
                        Engaging in token sales and crypto investments carries a high level of risk. Prices can fluctuate dramatically due to market conditions, regulatory updates, or changes in technology. Returns are not guaranteed, and there's a real possibility of losing some or all of your funds.
                    </div>
                    <div className="content-dis">
                        Before participating in any launch via TinyBlock, make sure to evaluate your financial capacity and risk profile. If unsure, consider seeking independent financial advice. TinyBlock holds no responsibility for losses related to your investment choices. By continuing, you confirm that you understand and accept these risks.
                    </div>
                    <img className='box-affter' src="/images/detail-ido/box-affter.png" alt="" />
                </div>
            </div>
        </>
    )
}

export default Disclaimer;